import React, { useContext, createContext, useState, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectUser } from '../reducers/userSlice'
import { COLOR_SCHEME_PREFERENCES } from '../constants/user'
import { isTestEnv } from 'tests/utils'
import { useRouter } from 'next/router'

const ColorSchemeContext = createContext<string>('light')


export const COLOR_SCHEMES = {
  light: 'light',
  dark: 'dark',
} as const

export const useColorScheme = () => useContext(ColorSchemeContext)

export const ColorSchemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [colorScheme, setColorScheme] = useState<string>(COLOR_SCHEMES.light)
  const [darkModeQuery, setDarkModeQuary] = useState<MediaQueryList | null>(null)
  const user = useSelector(selectUser)
  const router = useRouter()
  const isStudentInterface = router.pathname.includes('/portal')

  const onColorSchemeChange = useMemo(() => {
      return (event: { matches: boolean }) => {
        if (event.matches) {
          setColorScheme(COLOR_SCHEMES.dark)
        } else {
          setColorScheme(COLOR_SCHEMES.light)
        }
      }
    }, [],
  )

  useEffect(() => {
    // This doesnt work in tests
    if (!isTestEnv()) {
      setDarkModeQuary(window.matchMedia('(prefers-color-scheme: dark)'))
    }
  }, [])

  useEffect(() => {
    // Dark mode is only supported in the student portal interface
    if (!isStudentInterface) {
      setColorScheme(COLOR_SCHEMES.light)
      if (darkModeQuery) darkModeQuery.onchange = null
      return
    }

    if (!darkModeQuery) return
    if (user.colorSchemePreference === COLOR_SCHEME_PREFERENCES.SYSTEM) {
      onColorSchemeChange(darkModeQuery)
      darkModeQuery.onchange = onColorSchemeChange
    } else {
      darkModeQuery.onchange = null
      // darkModeQuery.removeEventListener('change', onColorSchemeChange)
      if (user.colorSchemePreference === COLOR_SCHEME_PREFERENCES.LIGHT) {
        setColorScheme(COLOR_SCHEMES.light)
      } else {
        setColorScheme(COLOR_SCHEMES.dark)
      }
    }
  }, [user, darkModeQuery, isStudentInterface])

  return <ColorSchemeContext.Provider value={colorScheme}>{children}</ColorSchemeContext.Provider>
}
